import { BASE_PATH as S, BaseAPI as j, operationServerMap as i } from "../base.js";
import { DUMMY_BASE_URL as k, assertParamExists as V, createRequestFunction as p, serializeDataIfNeeded as A, setSearchParams as v, toPathString as W } from "../common.js";
import O from "axios";
var x = function(r) {
  return {
    merchantWmsSkuAddSkuAndCategoryAndUnit: async (s, a = {}) => {
      V("merchantWmsSkuAddSkuAndCategoryAndUnit", "skuCategoryUnitVO", s);
      const o = new URL("/merchant/wms/sku/add_sku_category_unit", k);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...a
      }, n = {}, l = {};
      n["Content-Type"] = "application/json", v(o, l);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...n,
        ...c,
        ...a.headers
      }, e.data = A(s, e, r), {
        url: W(o),
        options: e
      };
    },
    merchantWmsSkuBatchDeleteSku: async (s, a = {}) => {
      V("merchantWmsSkuBatchDeleteSku", "requestBody", s);
      const o = new URL("/merchant/wms/sku/batch", k);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "DELETE",
        ...t,
        ...a
      }, n = {}, l = {};
      n["Content-Type"] = "application/json", v(o, l);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...n,
        ...c,
        ...a.headers
      }, e.data = A(s, e, r), {
        url: W(o),
        options: e
      };
    },
    merchantWmsSkuCreateSku: async (s, a = {}) => {
      V("merchantWmsSkuCreateSku", "wmsSkuGeneralDTO", s);
      const o = new URL("/merchant/wms/sku", k);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...a
      }, n = {}, l = {};
      n["Content-Type"] = "application/json", v(o, l);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...n,
        ...c,
        ...a.headers
      }, e.data = A(s, e, r), {
        url: W(o),
        options: e
      };
    },
    merchantWmsSkuCreateSkuV2: async (s, a = {}) => {
      V("merchantWmsSkuCreateSkuV2", "wmsSkuGeneralDTO", s);
      const o = new URL("/merchant/wms/sku/v2", k);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...a
      }, n = {}, l = {};
      n["Content-Type"] = "application/json", v(o, l);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...n,
        ...c,
        ...a.headers
      }, e.data = A(s, e, r), {
        url: W(o),
        options: e
      };
    },
    merchantWmsSkuDeleteSku: async (s, a = {}) => {
      V("merchantWmsSkuDeleteSku", "skuId", s);
      const o = "/merchant/wms/sku/{skuId}".replace("{skuId}", encodeURIComponent(String(s))), t = new URL(o, k);
      let e;
      r && (e = r.baseOptions);
      const n = {
        method: "DELETE",
        ...e,
        ...a
      }, l = {};
      v(t, {});
      let c = e && e.headers ? e.headers : {};
      return n.headers = {
        ...l,
        ...c,
        ...a.headers
      }, {
        url: W(t),
        options: n
      };
    },
    merchantWmsSkuGetObjectList: async (s, a, o, t, e, n, l = {}) => {
      const c = new URL("/merchant/wms/sku/list", k);
      let m;
      r && (m = r.baseOptions);
      const u = {
        method: "GET",
        ...m,
        ...l
      }, b = {}, h = {};
      s !== void 0 && (h.objectName = s), a !== void 0 && (h.skuId = a), o !== void 0 && (h.shopId = o), t !== void 0 && (h.categoryId = t), e !== void 0 && (h.limit = e), n !== void 0 && (h.page = n), v(c, h);
      let y = m && m.headers ? m.headers : {};
      return u.headers = {
        ...b,
        ...y,
        ...l.headers
      }, {
        url: W(c),
        options: u
      };
    },
    merchantWmsSkuGetObjectListByPage: async (s, a, o, t, e, n, l = {}) => {
      const c = new URL("/merchant/wms/sku/list/page", k);
      let m;
      r && (m = r.baseOptions);
      const u = {
        method: "GET",
        ...m,
        ...l
      }, b = {}, h = {};
      s !== void 0 && (h.objectName = s), a !== void 0 && (h.skuId = a), o !== void 0 && (h.shopId = o), t !== void 0 && (h.categoryId = t), e !== void 0 && (h.limit = e), n !== void 0 && (h.page = n), v(c, h);
      let y = m && m.headers ? m.headers : {};
      return u.headers = {
        ...b,
        ...y,
        ...l.headers
      }, {
        url: W(c),
        options: u
      };
    },
    merchantWmsSkuGetWmsExtraConfigInfo: async (s, a = {}) => {
      V("merchantWmsSkuGetWmsExtraConfigInfo", "skuIds", s);
      const o = new URL("/merchant/wms/sku/extra/info", k);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...a
      }, n = {}, l = {};
      s && (l.skuIds = s), v(o, l);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...n,
        ...c,
        ...a.headers
      }, {
        url: W(o),
        options: e
      };
    },
    merchantWmsSkuGetWmsSkuList: async (s, a = {}) => {
      V("merchantWmsSkuGetWmsSkuList", "query", s);
      const o = new URL("/merchant/wms/sku/list/v2", k);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...a
      }, n = {}, l = {};
      if (s !== void 0) for (const [m, u] of Object.entries(s)) l[m] = u;
      v(o, l);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...n,
        ...c,
        ...a.headers
      }, {
        url: W(o),
        options: e
      };
    },
    merchantWmsSkuGetWmsSkuListV3: async (s, a = {}) => {
      V("merchantWmsSkuGetWmsSkuListV3", "query", s);
      const o = new URL("/merchant/wms/sku/list/v3", k);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...a
      }, n = {}, l = {};
      if (s !== void 0) for (const [m, u] of Object.entries(s)) l[m] = u;
      v(o, l);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...n,
        ...c,
        ...a.headers
      }, {
        url: W(o),
        options: e
      };
    },
    merchantWmsSkuImportObject: async (s, a = {}) => {
      V("merchantWmsSkuImportObject", "skuVO", s);
      const o = new URL("/merchant/wms/sku/import", k);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...a
      }, n = {}, l = {};
      n["Content-Type"] = "application/json", v(o, l);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...n,
        ...c,
        ...a.headers
      }, e.data = A(s, e, r), {
        url: W(o),
        options: e
      };
    },
    merchantWmsSkuUpdateObjectStockAlertStatus: async (s, a = {}) => {
      V("merchantWmsSkuUpdateObjectStockAlertStatus", "objectStockAlertStatusVO", s);
      const o = new URL("/merchant/wms/sku/stock/alert/status", k);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "PUT",
        ...t,
        ...a
      }, n = {}, l = {};
      n["Content-Type"] = "application/json", v(o, l);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...n,
        ...c,
        ...a.headers
      }, e.data = A(s, e, r), {
        url: W(o),
        options: e
      };
    },
    merchantWmsSkuUpdateSku: async (s, a = {}) => {
      V("merchantWmsSkuUpdateSku", "wmsSkuGeneralDTO", s);
      const o = new URL("/merchant/wms/sku", k);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "PUT",
        ...t,
        ...a
      }, n = {}, l = {};
      n["Content-Type"] = "application/json", v(o, l);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...n,
        ...c,
        ...a.headers
      }, e.data = A(s, e, r), {
        url: W(o),
        options: e
      };
    },
    merchantWmsSkuUpdateSkuV2: async (s, a = {}) => {
      V("merchantWmsSkuUpdateSkuV2", "wmsSkuGeneralDTO", s);
      const o = new URL("/merchant/wms/sku/v2", k);
      let t;
      r && (t = r.baseOptions);
      const e = {
        method: "PUT",
        ...t,
        ...a
      }, n = {}, l = {};
      n["Content-Type"] = "application/json", v(o, l);
      let c = t && t.headers ? t.headers : {};
      return e.headers = {
        ...n,
        ...c,
        ...a.headers
      }, e.data = A(s, e, r), {
        url: W(o),
        options: e
      };
    }
  };
}, d = function(r) {
  const s = x(r);
  return {
    async merchantWmsSkuAddSkuAndCategoryAndUnit(a, o) {
      var t, e;
      const n = await s.merchantWmsSkuAddSkuAndCategoryAndUnit(a, o), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = i["MerchantWmsSkuApi.merchantWmsSkuAddSkuAndCategoryAndUnit"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => p(n, O, S, r)(m, c || u);
    },
    async merchantWmsSkuBatchDeleteSku(a, o) {
      var t, e;
      const n = await s.merchantWmsSkuBatchDeleteSku(a, o), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = i["MerchantWmsSkuApi.merchantWmsSkuBatchDeleteSku"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => p(n, O, S, r)(m, c || u);
    },
    async merchantWmsSkuCreateSku(a, o) {
      var t, e;
      const n = await s.merchantWmsSkuCreateSku(a, o), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = i["MerchantWmsSkuApi.merchantWmsSkuCreateSku"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => p(n, O, S, r)(m, c || u);
    },
    async merchantWmsSkuCreateSkuV2(a, o) {
      var t, e;
      const n = await s.merchantWmsSkuCreateSkuV2(a, o), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = i["MerchantWmsSkuApi.merchantWmsSkuCreateSkuV2"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => p(n, O, S, r)(m, c || u);
    },
    async merchantWmsSkuDeleteSku(a, o) {
      var t, e;
      const n = await s.merchantWmsSkuDeleteSku(a, o), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = i["MerchantWmsSkuApi.merchantWmsSkuDeleteSku"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => p(n, O, S, r)(m, c || u);
    },
    async merchantWmsSkuGetObjectList(a, o, t, e, n, l, c) {
      var m, u;
      const b = await s.merchantWmsSkuGetObjectList(a, o, t, e, n, l, c), h = (m = r == null ? void 0 : r.serverIndex) !== null && m !== void 0 ? m : 0, y = (u = i["MerchantWmsSkuApi.merchantWmsSkuGetObjectList"]) === null || u === void 0 || (u = u[h]) === null || u === void 0 ? void 0 : u.url;
      return (U, I) => p(b, O, S, r)(U, y || I);
    },
    async merchantWmsSkuGetObjectListByPage(a, o, t, e, n, l, c) {
      var m, u;
      const b = await s.merchantWmsSkuGetObjectListByPage(a, o, t, e, n, l, c), h = (m = r == null ? void 0 : r.serverIndex) !== null && m !== void 0 ? m : 0, y = (u = i["MerchantWmsSkuApi.merchantWmsSkuGetObjectListByPage"]) === null || u === void 0 || (u = u[h]) === null || u === void 0 ? void 0 : u.url;
      return (U, I) => p(b, O, S, r)(U, y || I);
    },
    async merchantWmsSkuGetWmsExtraConfigInfo(a, o) {
      var t, e;
      const n = await s.merchantWmsSkuGetWmsExtraConfigInfo(a, o), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = i["MerchantWmsSkuApi.merchantWmsSkuGetWmsExtraConfigInfo"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => p(n, O, S, r)(m, c || u);
    },
    async merchantWmsSkuGetWmsSkuList(a, o) {
      var t, e;
      const n = await s.merchantWmsSkuGetWmsSkuList(a, o), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = i["MerchantWmsSkuApi.merchantWmsSkuGetWmsSkuList"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => p(n, O, S, r)(m, c || u);
    },
    async merchantWmsSkuGetWmsSkuListV3(a, o) {
      var t, e;
      const n = await s.merchantWmsSkuGetWmsSkuListV3(a, o), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = i["MerchantWmsSkuApi.merchantWmsSkuGetWmsSkuListV3"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => p(n, O, S, r)(m, c || u);
    },
    async merchantWmsSkuImportObject(a, o) {
      var t, e;
      const n = await s.merchantWmsSkuImportObject(a, o), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = i["MerchantWmsSkuApi.merchantWmsSkuImportObject"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => p(n, O, S, r)(m, c || u);
    },
    async merchantWmsSkuUpdateObjectStockAlertStatus(a, o) {
      var t, e;
      const n = await s.merchantWmsSkuUpdateObjectStockAlertStatus(a, o), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = i["MerchantWmsSkuApi.merchantWmsSkuUpdateObjectStockAlertStatus"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => p(n, O, S, r)(m, c || u);
    },
    async merchantWmsSkuUpdateSku(a, o) {
      var t, e;
      const n = await s.merchantWmsSkuUpdateSku(a, o), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = i["MerchantWmsSkuApi.merchantWmsSkuUpdateSku"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => p(n, O, S, r)(m, c || u);
    },
    async merchantWmsSkuUpdateSkuV2(a, o) {
      var t, e;
      const n = await s.merchantWmsSkuUpdateSkuV2(a, o), l = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, c = (e = i["MerchantWmsSkuApi.merchantWmsSkuUpdateSkuV2"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (m, u) => p(n, O, S, r)(m, c || u);
    }
  };
}, B = function(r, s, a) {
  const o = d(r);
  return {
    merchantWmsSkuAddSkuAndCategoryAndUnit(t, e) {
      return o.merchantWmsSkuAddSkuAndCategoryAndUnit(t.skuCategoryUnitVO, e).then((n) => n(a, s));
    },
    merchantWmsSkuBatchDeleteSku(t, e) {
      return o.merchantWmsSkuBatchDeleteSku(t.requestBody, e).then((n) => n(a, s));
    },
    merchantWmsSkuCreateSku(t, e) {
      return o.merchantWmsSkuCreateSku(t.wmsSkuGeneralDTO, e).then((n) => n(a, s));
    },
    merchantWmsSkuCreateSkuV2(t, e) {
      return o.merchantWmsSkuCreateSkuV2(t.wmsSkuGeneralDTO, e).then((n) => n(a, s));
    },
    merchantWmsSkuDeleteSku(t, e) {
      return o.merchantWmsSkuDeleteSku(t.skuId, e).then((n) => n(a, s));
    },
    merchantWmsSkuGetObjectList(t = {}, e) {
      return o.merchantWmsSkuGetObjectList(t.objectName, t.skuId, t.shopId, t.categoryId, t.limit, t.page, e).then((n) => n(a, s));
    },
    merchantWmsSkuGetObjectListByPage(t = {}, e) {
      return o.merchantWmsSkuGetObjectListByPage(t.objectName, t.skuId, t.shopId, t.categoryId, t.limit, t.page, e).then((n) => n(a, s));
    },
    merchantWmsSkuGetWmsExtraConfigInfo(t, e) {
      return o.merchantWmsSkuGetWmsExtraConfigInfo(t.skuIds, e).then((n) => n(a, s));
    },
    merchantWmsSkuGetWmsSkuList(t, e) {
      return o.merchantWmsSkuGetWmsSkuList(t.query, e).then((n) => n(a, s));
    },
    merchantWmsSkuGetWmsSkuListV3(t, e) {
      return o.merchantWmsSkuGetWmsSkuListV3(t.query, e).then((n) => n(a, s));
    },
    merchantWmsSkuImportObject(t, e) {
      return o.merchantWmsSkuImportObject(t.skuVO, e).then((n) => n(a, s));
    },
    merchantWmsSkuUpdateObjectStockAlertStatus(t, e) {
      return o.merchantWmsSkuUpdateObjectStockAlertStatus(t.objectStockAlertStatusVO, e).then((n) => n(a, s));
    },
    merchantWmsSkuUpdateSku(t, e) {
      return o.merchantWmsSkuUpdateSku(t.wmsSkuGeneralDTO, e).then((n) => n(a, s));
    },
    merchantWmsSkuUpdateSkuV2(t, e) {
      return o.merchantWmsSkuUpdateSkuV2(t.wmsSkuGeneralDTO, e).then((n) => n(a, s));
    }
  };
}, C = class extends j {
  merchantWmsSkuAddSkuAndCategoryAndUnit(r, s) {
    return d(this.configuration).merchantWmsSkuAddSkuAndCategoryAndUnit(r.skuCategoryUnitVO, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuBatchDeleteSku(r, s) {
    return d(this.configuration).merchantWmsSkuBatchDeleteSku(r.requestBody, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuCreateSku(r, s) {
    return d(this.configuration).merchantWmsSkuCreateSku(r.wmsSkuGeneralDTO, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuCreateSkuV2(r, s) {
    return d(this.configuration).merchantWmsSkuCreateSkuV2(r.wmsSkuGeneralDTO, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuDeleteSku(r, s) {
    return d(this.configuration).merchantWmsSkuDeleteSku(r.skuId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuGetObjectList(r = {}, s) {
    return d(this.configuration).merchantWmsSkuGetObjectList(r.objectName, r.skuId, r.shopId, r.categoryId, r.limit, r.page, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuGetObjectListByPage(r = {}, s) {
    return d(this.configuration).merchantWmsSkuGetObjectListByPage(r.objectName, r.skuId, r.shopId, r.categoryId, r.limit, r.page, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuGetWmsExtraConfigInfo(r, s) {
    return d(this.configuration).merchantWmsSkuGetWmsExtraConfigInfo(r.skuIds, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuGetWmsSkuList(r, s) {
    return d(this.configuration).merchantWmsSkuGetWmsSkuList(r.query, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuGetWmsSkuListV3(r, s) {
    return d(this.configuration).merchantWmsSkuGetWmsSkuListV3(r.query, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuImportObject(r, s) {
    return d(this.configuration).merchantWmsSkuImportObject(r.skuVO, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuUpdateObjectStockAlertStatus(r, s) {
    return d(this.configuration).merchantWmsSkuUpdateObjectStockAlertStatus(r.objectStockAlertStatusVO, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuUpdateSku(r, s) {
    return d(this.configuration).merchantWmsSkuUpdateSku(r.wmsSkuGeneralDTO, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuUpdateSkuV2(r, s) {
    return d(this.configuration).merchantWmsSkuUpdateSkuV2(r.wmsSkuGeneralDTO, s).then((a) => a(this.axios, this.basePath));
  }
};
export {
  C as MerchantWmsSkuApi,
  x as MerchantWmsSkuApiAxiosParamCreator,
  B as MerchantWmsSkuApiFactory,
  d as MerchantWmsSkuApiFp
};

//# sourceMappingURL=merchant-wms-sku-api.js.map